export default __webpack_public_path__ + "static/media/Logo-Dark-Icon.001d89e4.svg";